const { __ } = wp.i18n;
import {
	Button,
	ButtonGroup,
	BaseControl,
	Disabled,
} from '@wordpress/components';


import UnitButton from '../../components/unit-button';

export default ( props ) => {
	const {
		adaptiveHeightResponsive,
		isFullScreen,
		slidesToShowResponsive,
		onChangeAdaptiveHeight,
		onChangeSliderHeight,
		onChangeAllSliderHeight,
		onChangeAllAdaptiveHeight,
		sliderHeightResponsive,
		animation,
		isVertical,
		isLinked,
	} = props;

	return (
		<BaseControl>
			<BaseControl.VisualLabel>{ __( 'Slider Height', 'gutenslider' ) }</BaseControl.VisualLabel>
			{ slidesToShowResponsive === 0 && ( animation === 'slide' || animation === 'coverflow' ) &&
				<Disabled>
					<BaseControl help={ 'Adaptive Height is disabled if you enabled Slides To Show: auto below' }>
						<ButtonGroup
							aria-label={ __( 'Adaptive Height', 'gutenslider' ) }
							className="gutenslider-toggle-adaptive-height"

						>
							<Button
								isSecondary={ false }
								isPrimary={ true }
								aria-pressed={ true }
							>
								{ __( 'fixed height', 'gutenslider' ) }
							</Button>
							<Button
								isSecondary={ true }
								isPrimary={ false }
								aria-pressed={ false }
							>
								{ __( 'adaptive height', 'gutenslider' ) }
							</Button>
						</ButtonGroup>
					</BaseControl>
				</Disabled>
			}
			{ isVertical && ! ( animation === 'slide' || animation === 'coverflow' ) &&
				<Disabled>
					<BaseControl help={ 'Adaptive Height is disabled if you enabled vertical slider' }>
						<ButtonGroup
							aria-label={ __( 'Adaptive Height', 'gutenslider' ) }
							className="gutenslider-toggle-adaptive-height"
						>
							<Button
								isSecondary={ false }
								isPrimary={ true }
								aria-pressed={ true }
							>
								{ __( 'fixed height', 'gutenslider' ) }
							</Button>
							<Button
								isSecondary={ true }
								isPrimary={ false }
								aria-pressed={ false }
							>
								{ __( 'adaptive height', 'gutenslider' ) }
							</Button>
						</ButtonGroup>
					</BaseControl>
				</Disabled>
			}
			{ ( slidesToShowResponsive !== 0 || ( animation !== 'slide' && animation !== 'coverflow' ) ) &&
				<BaseControl help={ adaptiveHeightResponsive ? __( 'Slides adapt their height to the background media', 'gutenslider' ) : __( 'All slides have the height you set below, unless the slide content is higher.', 'gutenslider' )}>
					<ButtonGroup aria-label={ __( 'Adaptive Height', 'gutenslider' ) } className="gutenslider-toggle-adaptive-height">
						<Button
							isSecondary={ adaptiveHeightResponsive === true }
							isPrimary={ adaptiveHeightResponsive === false }
							aria-pressed={ adaptiveHeightResponsive === false }
							onClick={ () => {
								isLinked ? onChangeAllAdaptiveHeight( false ) : onChangeAdaptiveHeight( false )
							} }
						>
							{ __( 'fixed height', 'gutenslider' ) }
						</Button>
						<Button
							isSecondary={ adaptiveHeightResponsive === false }
							isPrimary={ adaptiveHeightResponsive === true }
							aria-pressed={ adaptiveHeightResponsive === true }
							onClick={ () => {
								isLinked ? onChangeAllAdaptiveHeight( true ) : onChangeAdaptiveHeight( true )
							} }
						>
							{ __( 'adaptive height', 'gutenslider' ) }
						</Button>
					</ButtonGroup>
				</BaseControl>
			}
			{ ! isFullScreen && ! adaptiveHeightResponsive &&
				<UnitButton
					label={ props.label }
					units={ [
						{ value: 'vh', label: '%', default: 0, min: 20, max: 100 },
						{ value: 'px', label: 'px', default: 10, min: 100, max: 1500 },
					] }
					step={ 1 }
					transformUnits={ true }
					onChange={ isLinked ? onChangeAllSliderHeight : onChangeSliderHeight }
					value={ sliderHeightResponsive }
				/>
			}
		</BaseControl>
	);
}
